/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.validate',
  'acme.common.service.calendar',
  'acme.common.service.permissions',
  'acme.view.application.programs.removeModal.controllers',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.common.service.themesHelper',
  'acme.common.service.userPreferences'
])
.controller('ProgramsController', [
  '$scope',
  '$state',
  '$filter',
  '$timeout',
  '$uibModal',
  'ApiService',
  'PermissionsService',
  'ValidateService',
  'HelpersService',
  'CalendarService',
  'UserPreferencesService',
  'GridStateFactory',
  'GridDefinitionFactory',
  'CustomFieldsData',
  'ThemesHelperService',
  function ($scope,
            $state,
            $filter,
            $timeout,
            $uibModal,
            ApiService,
            PermissionsService,
            ValidateService,
            HelpersService,
            CalendarService,
            UserPreferencesService,
            GridStateFactory,
            GridDefinitionFactory,
            CustomFieldsData,
            ThemesHelperService) {

  $scope.programs = {
    gridState: new GridStateFactory(),
    gridDefinition: new GridDefinitionFactory(),
    strip: HelpersService.strip,
    model: {
      summaries: []
    },
    filtered: [],
    removeIndex: -1,
    isRemoving: false,
    isLoaded: false,
    searchQuery: '',
    queryTimer: false,
    eventTemplateGridName: $state.current.name+'.grid0',
    // use gridStateFactory for sorting options

    emailSetting: 'always',
    company: ThemesHelperService.getCompany(),
    dateTimeFormat: UserPreferencesService.getDateTimeFormat('sortDateTime'),
    
    optionsOverride: {
      rowHeight: 40,
      data: 'programs.model.summaries',
      appScopeProvider: {
        onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
          $scope.programs.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
        },
        onDataGridSortChange: function(grid, columns, page) {
          $scope.programs.onDataGridSortChange(grid, columns, page);
        },
        onDblClick: function (item) {
          $scope.programs.onDblClick(item);
        },
        remove: function (id) {
          $scope.programs.gridRemove(id);
        }
      },
      columnDefs: [
        {
          field: 'name',
          displayName: 'Name',
          visible: true,
          sort: {
            direction: 'asc'
          }
        },
        {
          field: 'displayDescription',
          colId: 'description',
          displayName: 'Description',
          visible: true,
          enableSorting: false
        },
        {
          field: 'soldQuantity',
          displayName: 'Sold',
          width: 50,
          visible: true
        },
        {
          field: 'reviewState',
          displayName: 'Status',
          width: 80,
          visible: true
        },
        {
          field: 'remove',
          displayName: 'Remove',
          onCellNavClick: function(row, col) {
            if (row.entity.soldQuantity === 0) {
              $scope.programs.optionsOverride.appScopeProvider.remove(row.entity.id);
            }
          },
          cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a role="button" data-ng-if="row.entity.soldQuantity === 0" data-permit="EVENT_TEMPLATE_DELETE" data-ng-click="grid.appScope.remove(row.entity.id)">Remove<span class="sr-only"> - Opens Dialog</span></a><span data-ng-if="row.entity.soldQuantity > 0">Booked</span></div>',
          visible: true,
          enableHiding: false,
          enableSorting: false,
          width: 70
        },
        {
          field: 'ratings',
          displayName: 'Ratings',
          width: 70,
          visible: false
        },
        {
          field: 'stars',
          displayName: 'Stars',
          width: 70,
          visible: true
        }
      ]
    },

    customFields: [],

    init: function () {
      var self = $scope.programs,
          editPermissionEnabled = PermissionsService.check('EVENT_TEMPLATE_UPDATE'),
          cellDisplayName = editPermissionEnabled ? 'Edit' : 'View',
          editCellTemplate = editPermissionEnabled ? '<div class="clickable programs-templates-list-action-cell ui-grid-cell-contents" ng-class="col.colIndex()"><div class="programs-templates-list-color" data-ng-style="row.entity.colorCodeStyle"><span class="sr-only">Background color: {{ row.entity.colorCodeStyle[\'background-color\'] }}, Text color: {{ row.entity.colorCodeStyle[\'color\'] }}</span></div>  <a data-ui-sref="application.templates.edit.description({ id: row.entity.id })" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>'
                            : '<div class="clickable programs-templates-list-action-cell ui-grid-cell-contents" ng-class="col.colIndex()"><div class="programs-templates-list-color" data-ng-style="row.entity.colorCodeStyle"><span class="sr-only">Background color: {{ row.entity.colorCodeStyle[\'background-color\'] }}, Text color: {{ row.entity.colorCodeStyle[\'color\'] }}</span></div> <a data-ng-click="grid.appScope.onDblClick(row)" role="link">View<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>';

      this.optionsOverride.columnDefs.unshift({
        field: 'edit',
        displayName: cellDisplayName,
        width: 50,
        onCellNavClick: function(row, col) {
          if (PermissionsService.check('EVENT_TEMPLATE_UPDATE')) {
            $state.go('application.templates.edit.description', { id: row.entity.id });
          } else {
            $scope.programs.optionsOverride.appScopeProvider.onDblClick(row);
          }
        },
        cellTemplate: editCellTemplate,
        visible: true,
        enableHiding: false,
        enableSorting: false
      });

      this.optionsOverride.columnDefs.push({
        field: 'startTime',
        displayName: 'Start Date',
        cellFilter: 'date: "'+ self.dateTimeFormat +'"',
        cellFormatter: function(item) {
          return $filter('date')(item.value, self.dateTimeFormat);
        },
        visible: true
      }),

      $scope.$emit('Application::contentTitleChange', {
        title: 'Event Templates',
        buttonRight: {
          label: 'Create Template',
          permissions: 'EVENT_TEMPLATE_CREATE',
          action: function () {
            $state.go('application.templates.create.description');
          },
          items: PermissionsService.check('EVENT_TEMPLATE_REORDER') ? [{
            label: 'Edit Display Order',
            sref: 'application.templates.reorder'
          }] : false
        }
      });

      if (CustomFieldsData.data && CustomFieldsData.data.success) {
        this.setCustomFields(CustomFieldsData);
      }

      this.viewId = $state.current.name;

      this.gridDefinition.init(this.eventTemplateGridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);

      $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);
      $scope.$on('ConflictInterceptor::update', this.onConflictUpdateState);

      this.getNotificationPreference();
    },

    getNotificationPreference: function() {
      if (this.company.hasOwnProperty('notificationPreference')) {
        this.emailSetting = this.company.notificationPreference;
      }
    },

    setCustomFields: function (customFieldsData) {
      var list = customFieldsData.data.payload.list,
          atIndex = this.optionsOverride.columnDefs.length;

      this.customFields = list;
      //ideally insert at after "scheduleName", Otherwise at end
      for (i=0,ii=this.optionsOverride.columnDefs.length; i < ii; i++) {
        if (this.optionsOverride.columnDefs[i].field === 'displayDescription') {
          atIndex = i;
          break;
        }
      }
      angular.forEach(list, function(customField, key) {
        $scope.programs.optionsOverride.columnDefs.splice(atIndex, 0, {
          field: customField.internalLabel,
          displayName: customField.label,
          visible: false
        });
        atIndex++;
      });
    },

    hasEvents: function() {
      return (this.model.summaries instanceof Array && this.model.summaries.length);
    },

    initData: function() {
      var self = $scope.programs, props = self.gridDefinition.getGridState();
      self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
      self.getSummaries($state.params.type, self.gridState.getGridState());
    },

    search: function() {
      if (this.queryTimer) {
        $timeout.cancel(this.queryTimer);
      }

      this.queryTimer = $timeout(function () {
        var self = $scope.programs;
        self.gridState.setPropertyValue('search', self.searchQuery);
        $scope.$broadcast('DataGrid::Search', {name: self.eventTemplateGridName});
      }, 500);
    },
    
    getSummaries: function (showPrivate, gridOptions) {
      ApiService.program.list(showPrivate, gridOptions).then(this.success.getSummaries, this.error.getSummaries);
    },

    findSummary: function(id) {
      var i, ii,
          r = false;

      if (this.hasEvents()) {
        for (i = 0, ii = this.model.summaries.length; i < ii; i++) {
          if (this.model.summaries[i].id === id) {
            r = {
              index: i,
              summary: this.model.summaries[i]
            };
            break;
          }
        }
      }

      return r;
    },

    removeProgram: function (id) {

      var self = $scope.programs,
          data = this.findSummary(id),
          summary = data.summary,
          summaryIndex = data.index,
          props = {};

      console.log('ProgramsController::removeProgram', id);
      self.modalDialog = $uibModal.open({
        templateUrl: 'views/application/views/programs/modals/removeEvent.tpl.html',
        size: 'md',
        controller: 'ProgramsRemoveModalController',
        resolve: {
          currentEvent: function() {
            return summary;
          },
          SoldQuantity: function() {
            return summary.soldQuantity;
          },
          emailSetting: function () {
            return self.emailSetting;
          }
        }
      });

      // Invoked when modal completes with close(params)
      self.modalDialog.result.then(function (sendEmail) {
        props = {
          id: id,
          sendEmail: sendEmail
        };
        self.isRemoving = true;
        ApiService.program.remove(props).then(function(response, status, headers, config) {
          self.model.summaries.splice(summaryIndex, 1);
          self.success.removeProgram(response, status, headers, config);
        }, function(response, status, headers, config) {
          self.error.removeProgram(response, status, headers, config);
        });
      }, function () {
        // Do nothing
      });

    },

    process: function(summaries) {
      var i, ii,
          j, jj;

      for (i=0,ii=summaries.length;i<ii;i++) {
        summaries[i].endTime = (summaries[i].endTime) ? CalendarService.parseDate(summaries[i].endTime) : 'Indefinite';
        summaries[i].displayDescription = (summaries[i].shortDescription) ? HelpersService.strip(summaries[i].shortDescription, 80) : HelpersService.strip(summaries[i].description, 80);
        summaries[i].reviewState = HelpersService.cap(summaries[i].reviewState);
        if (summaries[i].colorCategory && summaries[i].colorCategory.textColor) {
          summaries[i].colorCodeStyle = {
            'height': '100%',
            'width': '4px',
            'color': summaries[i].colorCategory.textColor,
            'background-color': summaries[i].colorCategory.backgroundColor,
            'position': 'absolute',
            'top': '0px',
            'left': '0px'
          };
        }
        for (j=0, jj=this.customFields.length; j < jj; j++) {
          summaries[i][this.customFields[j].internalLabel] = HelpersService.getCustomFieldValue(summaries[i], this.customFields[j].label);
        }
      }

      return summaries;
    },

    success: {
      getSummaries: function (response, status, headers, config) {
        var self = $scope.programs;

        self.isLoaded = true;
        self.model.summaries = self.process(response.data.payload.list);
        self.isLoaded = true;
        self.gridDefinition.isLoaded = true;

        if (!$scope.$$phase) {
          $scope.$apply();
        }
        $timeout(function() {
          $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.summaries.length, totalItems: response.data.payload.pagination.count});
        }, 10);
      },
      removeProgram: function (response, status, headers, config) {
        var self = $scope.programs;
        self.gridDefinition.isLoaded = true;
        $timeout(function() {
          $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.summaries.length, totalItems: self.gridDefinition.options.totalItems-1});
        }, 10);
      }
    },
    error: {
      getSummaries: function (response, status, headers, config) {
        //TODO: Need to implement
      },
      removeProgram: function (response, status, headers, config) {
        //TODO: Need to implement
      }
    },
    showList : function() {
      return $scope.programs.model.summaries !== null && $scope.programs.model.summaries.length > 0;
    },

    onDblClick: function(params) {
      $state.go('application.programsDetail.overview', { id: params.entity.id });
    },

    gridRemove: function() {
      var args = Array.prototype.slice.call(arguments);
      $scope.programs.removeProgram.apply($scope.programs, args);
    },

    onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
      var self = $scope.programs;
      self.gridState.updateGridState(newPage, pageSize);
      if (sortField) {
        self.gridState.updateGridState(null, null, sortField, null);
      }
      if (sortDirection) {
        self.gridState.updateGridState(null, null, null, sortDirection);
      }
        self.getSummaries($state.params.type, self.gridState.getGridState());
    },
    
    onDataGridSortChange: function(grid, columns, page) {
      var self = $scope.programs, data = columns[0];
      self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
      self.getSummaries($state.params.type, self.gridState.getGridState());
    },

    onConflictUpdateState: function(e, data) {
      $state.go('application.templates.edit.description', {id: data.id, force: data.forceEdit});
    }

  };

  $scope.programs.init();
}]);